export default function isDefined<Type>(
	value: Type | undefined,
): value is Type {
	return value !== undefined;
}
